import Page from './Page'

export * from './Page'

export default Page
